import config from "@client/config";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Box from '@mui/material/Box';
import { getRCRedirectUri } from "@client/utils";

import CloseIcon from "@mui/icons-material/Close";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import styles from "./style";

export default function AccessDeniedComponent({ isOpen = false }) {
  const { rc_client_Id, rc_authorize_uri, apiBaseUrl } = config;

  const redirectToLogin = () => {
    if (typeof window !== "undefined") {
      window.location.replace(
        getRCRedirectUri(
          rc_authorize_uri,
          rc_client_Id,
          apiBaseUrl,
          window.location.origin
        )
      );
    }
  };

  return (
    <Dialog open={isOpen} onClose={redirectToLogin}>
      <DialogTitle sx={styles.dialogTitle}>
        <IconButton onClick={redirectToLogin}>
          <CloseIcon sx={{ color: '#B0B0B0' }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        <Box sx={{ mt: 2 }}>
          <img height={116} alt="Alert Icon" src="/assets/error-icon.svg" />
        </Box>
        {/* <WarningRoundedIcon
          fontSize="large"
          color="error"
          sx={styles.infoBtn}
        /> */}
        <Typography variant="h4" sx={styles.heading}>
          Access Denied
        </Typography>
        <Typography variant="body1">
          Please contact your RingCentral Account
        </Typography>
        <Typography variant="body1">Administrator for access.</Typography>
      </DialogContent>
      <DialogActions sx={styles.actions}>
        <Button
          onClick={redirectToLogin}
          variant="contained"
          color="primary"
          sx={styles.actionButtons}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
